export default {
      id: "ic-plan-enfance-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-enfance-usage",
      toString: function () {
        return this.url;
      }
    }